// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2647":"0f14821d","4528":"cfe8126a","8635":"49b9b1ff"}[chunkId] + ".chunk.css";
};